import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { SNS_LINKS } from '../../domain/consultation-counter/constants';
import * as styles from './HamburgerMenu.module.css';
import { Link as GatsbyLink } from 'gatsby';
import Divider from '../common_ui/Divider';
import Image from '../common_ui/Image';

export interface NavLinkButtonProps {
  children: React.ReactNode;
  to: string;
  onClick?: () => void;
}

const NavLinkButton: React.FC<NavLinkButtonProps> = ({
  children,
  to,
  onClick,
}) => {
  return (
    <GatsbyLink to={to} className={styles.navButton} onClick={onClick}>
      <span className={styles.navButtonContent}>
        {children}
        <span className={styles.navButtonArrow} aria-hidden='true'>
          <Image
            src='/svg/arrow_right.svg'
            alt=''
            className={styles.navButtonArrowIcon}
          />
        </span>
      </span>
    </GatsbyLink>
  );
};

export interface CompactNavButtonProps {
  children: React.ReactNode;
  to: string;
  onClick?: () => void;
}

const CompactNavButton: React.FC<CompactNavButtonProps> = ({
  children,
  to,
  onClick,
}) => {
  return (
    <GatsbyLink to={to} className={styles.compactNavButton} onClick={onClick}>
      <span className={styles.compactNavButtonContent}>
        {children}
        <span className={styles.compactNavLinkArrow} aria-hidden='true'>
          <img
            src='/svg/arrow_right.svg'
            alt=''
            className={styles.compactButtonArrowIcon}
          />
        </span>
      </span>
    </GatsbyLink>
  );
};

interface MobileNavigationProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
  navRef: React.RefObject<HTMLElement>;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  isMenuOpen,
  onToggleMenu,
  navRef,
}) => {
  return (
    <nav
      id='mobile-nav'
      ref={navRef}
      className={`${styles.mobileNav} ${isMenuOpen ? styles.active : ''}`}
      aria-label='ナビゲーション'
      aria-hidden={!isMenuOpen}
    >
      <div className={styles.mobileNavContent}>
        <ul className={styles.navList}>
          <li className={styles.navItem}>
            <Link
              to='/#about'
              className={styles.navLink}
              onClick={onToggleMenu}
            >
              <div className={styles.navLinkContent}>
                <span className={styles.navLinkText}>
                  プレコンセプションケアとは？
                </span>
              </div>
              <div className={styles.navLinkArrow}>
                <Image src='/svg/arrow_right.svg' alt='' />
              </div>
            </Link>
            <div className={styles.navItemDivider}></div>
          </li>
          <li className={styles.navItem}>
            <Link to='/manga' className={styles.navLink} onClick={onToggleMenu}>
              <div className={styles.navLinkContent}>
                <span className={styles.navLinkText}>マンガでプレコン！</span>
              </div>
              <div className={styles.navLinkArrow}>
                <Image src='/svg/arrow_right.svg' alt='' />
              </div>
            </Link>
            <div className={styles.navItemDivider}></div>
          </li>
          <li className={styles.navItem}>
            <Link
              to='/dictionary'
              className={styles.navLink}
              onClick={onToggleMenu}
            >
              <div className={styles.navLinkContent}>
                <span className={styles.navLinkText}>プレコン Dictionary</span>
              </div>
              <div className={styles.navLinkArrow}>
                <Image src='/svg/arrow_right.svg' alt='' />
              </div>
            </Link>
            <div className={styles.navItemDivider}></div>
          </li>
          <li className={styles.navItem}>
            <Link
              to='/soudan'
              className={styles.navLink}
              onClick={onToggleMenu}
            >
              <div className={styles.navLinkContent}>
                <span className={styles.navLinkText}>相談窓口一覧</span>
              </div>
              <div className={styles.navLinkArrow}>
                <Image src='/svg/arrow_right.svg' alt='' />
              </div>
            </Link>
            <div className={styles.navItemDivider}></div>
          </li>
          <li className={styles.navItem}>
            <Link to='/event' className={styles.navLink} onClick={onToggleMenu}>
              <div className={styles.navLinkContent}>
                <span className={styles.navLinkText}>
                  シンポジウム・イベント情報
                </span>
              </div>
              <div className={styles.navLinkArrow}>
                <Image src='/svg/arrow_right.svg' alt='' />
              </div>
            </Link>
            <div className={styles.navItemDivider}></div>
          </li>
          <li className={styles.navItem}>
            <Link
              to='/contact'
              className={styles.navLink}
              onClick={onToggleMenu}
            >
              <div className={styles.navLinkContent}>
                <span className={styles.navLinkText}>お問い合わせ</span>
              </div>
              <div className={styles.navLinkArrow}>
                <Image src='/svg/arrow_right.svg' alt='' />
              </div>
            </Link>
          </li>
        </ul>

        <div className={styles.navButtonListContainer}>
          <ul className={styles.navButtonList}>
            <li>
              <NavLinkButton to='/jichitai' onClick={onToggleMenu}>
                自治体の方へ
              </NavLinkButton>
            </li>
            <li>
              <NavLinkButton to='/iryou' onClick={onToggleMenu}>
                医療機関の方へ
              </NavLinkButton>
            </li>
            <li>
              <NavLinkButton to='/precon-supporter' onClick={onToggleMenu}>
                プレコンサポーターの方へ
              </NavLinkButton>
            </li>
            <Divider margin='-8px 0' className={styles.divider} />
            <li>
              <NavLinkButton to='/shizai' onClick={onToggleMenu}>
                プレコン普及啓発資材
              </NavLinkButton>
            </li>
          </ul>
        </div>

        <div className={styles.socialLinks}>
          <a
            href={SNS_LINKS.instagram}
            target='_blank'
            rel='noopener noreferrer'
            className={styles.socialButton}
            aria-label='Instagramを開く（新しいタブ）'
          >
            <div className={styles.socialLinkContent}>
              <div className={styles.socialIcon}>
                <StaticImage
                  src='../../../static/img/instagram.png'
                  alt='Instagram'
                  placeholder='blurred'
                />
              </div>
            </div>
          </a>
          <a
            href={SNS_LINKS.youtube}
            target='_blank'
            rel='noopener noreferrer'
            className={styles.socialButton}
            aria-label='YouTubeを開く（新しいタブ）'
          >
            <div className={styles.socialLinkContent}>
              <div className={styles.socialIcon}>
                <StaticImage
                  src='../../../static/img/youtube.png'
                  alt='YouTube'
                  placeholder='blurred'
                />
              </div>
            </div>
          </a>
        </div>
        <small>
          ※当事業の公式SNSアカウントは、本サイトに掲載しているもののみとなります。それ以外のなりすましアカウントには十分ご注意ください
        </small>
      </div>
    </nav>
  );
};

interface CompactNavigationProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
  navRef: React.RefObject<HTMLElement>;
}

const CompactNavigation: React.FC<CompactNavigationProps> = ({
  isMenuOpen,
  onToggleMenu,
  navRef,
}) => {
  return (
    <nav
      id='mobile-nav'
      ref={navRef}
      className={`${styles.compactNav} ${isMenuOpen ? styles.active : ''}`}
      aria-label='ナビゲーション'
      aria-hidden={!isMenuOpen}
    >
      <div>
        <div className={styles.compactNavContent}>
          <div className={styles.compactNavItemList}>
            <CompactNavButton to='/#about' onClick={onToggleMenu}>
              プレコンセプションケアとは？
            </CompactNavButton>
            <CompactNavButton to='/manga' onClick={onToggleMenu}>
              マンガでプレコン！
            </CompactNavButton>
            <CompactNavButton to='/dictionary' onClick={onToggleMenu}>
              プレコン Dictionary
            </CompactNavButton>
            <CompactNavButton to='/soudan' onClick={onToggleMenu}>
              相談窓口一覧
            </CompactNavButton>
            <CompactNavButton to='/event' onClick={onToggleMenu}>
              シンポジウム・イベント情報
            </CompactNavButton>
          </div>
          <div className={styles.compactNavItemList}>
            <CompactNavButton to='/contact' onClick={onToggleMenu}>
              お問い合わせ
            </CompactNavButton>
          </div>
        </div>
      </div>
    </nav>
  );
};

interface HamburgerMenuProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
  mobileNavRef: React.RefObject<HTMLElement>;
  compactNavRef: React.RefObject<HTMLElement>;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  isMenuOpen,
  onToggleMenu,
  mobileNavRef,
  compactNavRef,
}) => {
  return (
    <>
      {/* オーバーレイ */}
      {isMenuOpen && (
        <div
          className={styles.overlay}
          onClick={onToggleMenu}
          aria-hidden='true'
        />
      )}

      {/* モバイル用ドロワーナビゲーション (860px以下) */}
      <MobileNavigation
        isMenuOpen={isMenuOpen}
        onToggleMenu={onToggleMenu}
        navRef={mobileNavRef}
      />

      {/* PC用ドロワーナビゲーション (861px以上1350px以下) */}
      <CompactNavigation
        isMenuOpen={isMenuOpen}
        onToggleMenu={onToggleMenu}
        navRef={compactNavRef}
      />
    </>
  );
};

export default HamburgerMenu;
